import React, { useState } from "react";
import {
  Modal,
  Form,
  Input,
  Button,
  Row,
  Col,
  DatePicker,
  Steps,
  message,
  Radio,
  Alert,
} from "antd";
import "dayjs/locale/es-mx";
import store from "../../../../../controllers/store";
import { useSelector } from "react-redux";
import { InboxOutlined } from "@ant-design/icons";
import { Upload } from "antd";
import { create } from "../../../../../controllers/store/actions/events/create-event-action";
import { UploadImageEvent } from "../../../../../controllers/store/actions/events/upload-image-action";

const { Dragger } = Upload;

interface Props {
  visible: boolean;
  onCreated: () => void;
  onCancel: () => void;
}

const dispatch = store.dispatch;

const NewEventModal: React.FC<Props> = (props: Props) => {
  const [form] = Form.useForm();
  const [formGlobal, setFormGlobal] = useState<any>({});
  const createdEvent = useSelector((state: any) => state.createdEvent);
  const eventImageState = useSelector((state: any) => state.eventImage);
  const [current, setCurrent] = useState(0);

  const next = () => {
    form
      .validateFields()
      .then(async (values: any) => {
        setFormGlobal({
          ...formGlobal,
          ...values,
          banner: eventImageState.upload?.id,
        });
        setCurrent(current + 1);
      })
      .catch((e: any) => {
        console.log(e.message);
      });
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "Información básica del evento",
      content: (
        <>
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col span={24}>
              <Form.Item
                label="Nombre del evento"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese el nombre del evento",
                  },
                ]}
              >
                <Input placeholder="Nombre del evento" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Url del registro"
                name="url"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la url de registro.",
                  },
                ]}
              >
                <Input placeholder="URl de registro o evento" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Tipo de evento"
                name="type"
                rules={[
                  {
                    required: true,
                    message: "Por favor seleccione el tipo de evento",
                  },
                ]}
              >
                <Radio.Group
                  options={[
                    { label: "Virtual", value: "Virtual" },
                    { label: "Presencial", value: "Presencial" },
                    { label: "Mixto", value: "Mixto" },
                  ]}
                  optionType="button"
                  buttonStyle="solid"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Ubicación"
                name="location"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la ubicación del evento",
                  },
                ]}
              >
                <Input placeholder="ubicación del evento" />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="Nombre del organizador"
                name="organizer_fullname"
                rules={[
                  {
                    required: true,
                    message:
                      "Por favor ingrese el nombre del organizador del evento",
                  },
                ]}
              >
                <Input placeholder="Nombre del organizador del evento" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Fecha inicio de visibilidad"
                name="visibility_start_date"
                rules={[
                  {
                    required: true,
                    message:
                      "Por favor ingrese la fecha de inicio de visibilidad",
                  },
                ]}
              >
                <DatePicker
                  showTime={{ format: "hh:mm A", use12Hours: true }}
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Fecha de inicio de visibilidad"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Fecha fin de visibilidad"
                name="visibility_end_date"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la fecha de fin de visibilidad",
                  },
                ]}
              >
                <DatePicker
                  showTime={{ format: "hh:mm A", use12Hours: true }}
                  style={{ width: "100%" }}
                  size="large"
                  placeholder="Fecha de fin de visibilidad"
                />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: "Información de detalle",
      content: (
        <>
          <Row gutter={[8, 8]} style={{ width: "100%", marginTop: 30 }}>
            <Col span={24}>
              <Form.Item
                label="Descripción detallada"
                name="description"
                rules={[
                  {
                    required: true,
                    message: "Por favor ingrese la descripción detallada",
                  },
                ]}
              >
                <Input.TextArea placeholder="Descripción detallada" />
              </Form.Item>
            </Col>
          </Row>
        </>
      ),
    },
    {
      title: "Presentación",
      content: (
        <>
          <br />
          <Alert
            message="Se recomienda subir el banner con las dimensiones 1920x520 píxeles para obtener una mejor visualización."
            type="info"
          />
          <br />
          <Dragger
            name="file"
            multiple
            action="https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188"
            onChange={(info) => {
              const { status } = info.file;
              if (status !== "uploading") {
                console.log(info.file, info.fileList);
              }
              if (status === "done") {
                message.success(
                  `${info.file.name} Archivo subido correctamente.`
                );
              } else if (status === "error") {
                message.error(`${info.file.name} Falló la subida del archivo.`);
              }
            }}
            onDrop={(e) => {
              console.log("Dropped files", e.dataTransfer.files);
            }}
            customRequest={async ({ file, onSuccess, onError }) => {
              try {
                await dispatch(UploadImageEvent(file as File));
                if (onSuccess) onSuccess("Ok");
              } catch (e: any) {
                if (onError) {
                  onError(e);
                }
              }
            }}
            style={{ marginTop: 20 }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Click o arrastra los archivos a esta área para subir.
            </p>
            <p className="ant-upload-hint">Agrega el banner de este evento.</p>
          </Dragger>
        </>
      ),
    },
  ];

  const handleFinish = async () => {
    try {
      console.log("globa", formGlobal);
      await dispatch(
        create({
          ...formGlobal,
          banner: eventImageState.upload?.id,
        })
      );
      props.onCreated();
    } catch (error) {
      console.error("Error al crear la convocatoria", error);
    }
  };

  return (
    <Modal
      width={800}
      visible={props.visible}
      title={"Eventos"}
      footer={
        <div style={{ marginTop: 24 }}>
          {current < steps.length - 1 && (
            <Button type="primary" onClick={() => next()}>
              Siguiente
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button
              loading={createdEvent.isLoading}
              type="primary"
              onClick={handleFinish}
            >
              Guardar
            </Button>
          )}
          {current > 0 && (
            <Button style={{ margin: "0 8px" }} onClick={() => prev()}>
              Anterior
            </Button>
          )}
        </div>
      }
      onCancel={props.onCancel}
    >
      <>
        <Steps
          current={current}
          items={steps.map((item) => ({ key: item.title, title: item.title }))}
        />
        <Form form={form} layout="vertical" name="newEvent">
          {steps[current].content}
        </Form>
      </>
    </Modal>
  );
};

export default NewEventModal;
